import store from 'utils/store/withMiddleware'
import clickEventName from 'utils/DOM/clickEventName'
import fitPlanConfigurationForFilter from 'sites/pivothealth.com/short-term-health-insurance/consumer/quotes/utils/fitPlanConfigurationForFilter'
import generatePlanFilter from 'utils/pivot/plan/generatePlanFilter'
import toastNotification from 'pug/toastNotification'
import { FILTER_CHANGED } from 'messages'
import { preventOnCloseEvent } from 'core/services/onClose'
import toggleClass from 'utils/DOM/toggleClass'
import sortTable from './controller/sort-table'

export default function () {
  $(document.body)
    .on(clickEventName, '.js-remove-compare-plan', removePlan)
    .on(clickEventName, '.js-restore-plan', restorePlan)
    .on(clickEventName, '.js-add-new-plan', addPlan)
    .on('change', '#diff', sortTable)
    .on('change', '.js-option', changePlan)
    .on(clickEventName, '#View\\ Details\\ \\&\\ Customize', function () {
      preventOnCloseEvent()
    })
    .on(clickEventName, '.plan-switch__skip', () =>
      toggleClass('#plan-switch__wrap', 'd-none', true)
    )
}

function changePlan() {
  preventOnCloseEvent()
  const state = store.getState()
  const { plansToShow, plans, filtersByProductType } = state

  const planIndex = this.id.split('-')[1]
  const planKey = plansToShow[planIndex]
  const planId = planKey.split('-')[0]
  const plan = plans[planId]

  const filterName = this.name.split('-')[1]
  const filterValue = this.value

  const planTypeKey = plan.planTypeKey

  const newFiltersByProductType = {
    [planTypeKey]: generatePlanFilter({
      plan,
      policies: filtersByProductType[planIndex].policies,
      period: filtersByProductType[planIndex].period
    })
  }

  const { alternativePlanId, hasForceFilterChange, planFilter } =
    fitPlanConfigurationForFilter({
      planTypeKey,
      filters: [{ filterName, filterValue }],
      filtersByProductType: newFiltersByProductType
    })

  const newPlansToShow = plansToShow
  if (alternativePlanId) {
    newPlansToShow[
      planIndex
    ] = `${alternativePlanId}-${planFilter.period}-${planFilter.policies}`
  }

  store.update({
    plansToShow: newPlansToShow,
    filtersByProductType: {
      ...filtersByProductType,
      [planIndex]: newFiltersByProductType[planTypeKey]
    }
  })

  if (hasForceFilterChange) {
    toastNotification(FILTER_CHANGED, 2500)
  }
}

function removePlan(): void {
  const { removedPlans, plansToShow } = <ComparePage.State>store.getState()
  if (plansToShow.length === 1) {
    return
  }

  const planIndex = +this.dataset.planindex

  removedPlans.push({
    id: plansToShow[planIndex],
    oldIndex: planIndex
  })
  plansToShow.splice(planIndex, 1)
  store.update({ removedPlans, plansToShow })
}

function restorePlan(): void {
  const { removedPlans, plansToShow } = <ComparePage.State>store.getState()
  const lastRemovedPlan = removedPlans.pop()

  plansToShow.splice(lastRemovedPlan.oldIndex, 0, lastRemovedPlan.id)

  store.update({ removedPlans, plansToShow })
}

function addPlan(): void {
  const { plansToShow, removedPlans, defaultPlans } = <ComparePage.State>store.getState()

  const planId = this.dataset.planindex

  const planKey = Object.keys(defaultPlans).find(
    planKey => planKey.includes(planId) && !plansToShow[planKey]
  )

  if (!planKey) {
    return
  }

  plansToShow.push(planKey)
  const newRemovedPlans = removedPlans.filter(({ id }) => String(id) !== planKey)

  if (plansToShow.length === 3) {
    removedPlans.length = 0
  }

  store.update({ plansToShow, removedPlans: newRemovedPlans })
}
